import * as React from 'react';
import { Link, LinkProps, styled } from '@mui/material';

import { weights } from '../context';

type CerebroLinkProps<TComponent extends React.ElementType<any> = 'a'> = Omit<
	LinkProps<TComponent>,
	'variant' | 'ref' | 'fontWeight'
> & {
	component?: TComponent;

	variant?: 'extra-small' | 'small' | 'large' | 'data' | 'hint' | 'error' | 'breadcrumb' | 'link';
	weight?: keyof typeof weights;
};

export function CerebroLink<TComponent extends React.ElementType<any> = 'a'>({
	variant = 'small',
	weight = 'medium',
	children,
	...props
}: CerebroLinkProps<TComponent>) {
	let muiVariant: LinkProps['variant'] = 'body1';

	switch (variant) {
		case 'extra-small':
			muiVariant = 'body3';
			break;

		case 'small':
			muiVariant = 'body2';
			break;

		case 'large':
			muiVariant = 'body1';
			break;

		case 'data':
			muiVariant = 'data';
			break;

		case 'link':
			muiVariant = 'link';
			break;
	}

	return (
		<StyledLink fontWeight={weights[weight]} variant={muiVariant} {...props}>
			{children}
		</StyledLink>
	);
}

const StyledLink = styled(Link)(({ theme }) => ({
	color: theme.palette.gray.dark,
	textDecorationColor: theme.palette.primary.main,
	textDecorationThickness: 2,

	':hover': {
		textDecorationColor: theme.palette.primary.light,
		textDecorationThickness: 3,
		textDecoration: 'underline !important',
	},
}));
